import React from 'react';
import { connect } from 'react-redux';
import map from 'lodash/map';

import Loader from "../../../../../components/Loader";
import { fetchStatsCardsIfNeeded } from "../../../../../actions/app/mpt/stats";

import './MptCardsStatsWidget.css'


class MptCardsStatsWidget extends React.Component {
    constructor(){
        super();
        this.state = {
            totCards: 0,
            totUsers: 0,
        }
    }
    componentDidMount() {
        this.props.dispatch(fetchStatsCardsIfNeeded())
    }

    render() {
        const { info, stats } = this.props;
        let totCards = 0;
        let totUsers = 0;
        return (
            <div id="MptCardsStatsWidget">
                <div className="box box-default">
                    <div className="box-header with-border">
                        <h3 className="box-title pull-left">
                            <i className="fa fa-address-card-o"/> Cards and users statistics
                        </h3>
                    </div>
                    <div className="box-body">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="table-responsive table-fixed-height">
                                    <table className="table table-bordered no-margin">
                                        <thead>
                                        <tr>
                                            <th className="text-center">Weeks</th>
                                            <th className="text-center">Cards</th>
                                            <th className="text-center">Users</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {
                                            stats && map(stats.nbCardsByWeek, (s, i) => {
                                                totCards = totCards + s;
                                                totUsers = totUsers + stats.nbUserByWeek[i];
                                                return (
                                                    <tr className="text-center">
                                                        <th className="text-center">{i}</th>
                                                        <th className="text-center">{s}</th>
                                                        <th className="text-center">{stats.nbUserByWeek[i]}</th>
                                                    </tr>
                                                )
                                            })
                                        }
                                        <tr className="text-center">
                                            <th className="text-center">Total</th>
                                            <th className="text-center">{totCards}</th>
                                            <th className="text-center">{totUsers}</th>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        {info.isFetching && <Loader/>}
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(
    state => ({
        info: state.app.mpt.cardsStats.info,
        stats: state.app.mpt.cardsStats.stats,
    }),
    dispatch => ({ dispatch }),
)(MptCardsStatsWidget);



// WEBPACK FOOTER //
// ./src/pages/MPT/Stats/Widgets/Cards/index.js